// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3Dizu","inner":"Form_inner__3i-pd","range":"Form_range__-mZCM","name":"Form_name__iL16P","actions":"Form_actions__1e0TU"};